import { render } from "./proposerArticleView.vue?vue&type=template&id=cd228f0c&scoped=true"
import script from "./proposerArticleView.vue?vue&type=script&lang=js"
export * from "./proposerArticleView.vue?vue&type=script&lang=js"

import "./proposerArticleView.vue?vue&type=style&index=0&id=cd228f0c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cd228f0c"]])

export default __exports__